import dayjs from 'dayjs';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { EventProps } from 'react-big-calendar';

import { IContentGridCalendarEvent } from '../Content.types';
import { useCalendarEventPresenter } from './CalendarEvent.presenter';
import { ICalendarEventProps } from './CalendarEvent.types';

export const CalendarEvent: FC<EventProps<IContentGridCalendarEvent> & ICalendarEventProps> =
  observer(({ event, currentView, getMyEventStatus }) => {
    const presenter = useCalendarEventPresenter({
      start: dayjs(event.displayStart),
      end: dayjs(event.displayEnd),
      isTemplate: !!event.isTemplate,
      currentView,
      allDay: event.allDay,
      participants: event.participants,
      providerEmail: event.account.providerEmail,
      getMyEventStatus,
    });

    return (
      <span className={`event-container ${presenter.wrapClass} ${presenter.containerClass}`}>
        {presenter.isTimeBeforContent && (
          <span className="event-content-prev-sub-title">{presenter.startTime}</span>
        )}
        <span className="event-content-title">{event.title}</span>
        {presenter.isTimeAfterContent &&
          (presenter.isWrapContent ? (
            <span className="event-content-sub-title">{`${presenter.startTime} - ${presenter.endTime}`}</span>
          ) : (
            `${presenter.startTime} - ${presenter.endTime}`
          ))}
      </span>
    );
  });
